// This file is auto-generated by the `update-kc-gen` command. Do not edit it manually.
// Hash: 5a8c6edca622f5e71fee3171370e950bf84433285ac900a7df0515299c084344

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

import { lazy, Suspense, type ReactNode } from 'react';

export type ThemeName = 'tpl-enersee-keycloak-2';

export const themeNames: ThemeName[] = ['tpl-enersee-keycloak-2'];

export type KcEnvName = never;

export const kcEnvNames: KcEnvName[] = [];

export const kcEnvDefaults: Record<KcEnvName, string> = {};

/**
 * NOTE: Do not import this type except maybe in your entrypoint.
 * If you need to import the KcContext import it either from src/login/KcContext.ts or src/account/KcContext.ts.
 * Depending on the theme type you are working on.
 */
export type KcContext = import('./login/KcContext').KcContext;

declare global {
  interface Window {
    kcContext?: KcContext;
  }
}

export const KcLoginPage = lazy(() => import('./login/KcPage'));

export function KcPage(props: { kcContext: KcContext; fallback?: ReactNode }) {
  const { kcContext, fallback } = props;

  let pageComponent: JSX.Element | null = null;

  switch (kcContext.themeType) {
    case 'login':
      pageComponent = <KcLoginPage kcContext={kcContext} />;
      break;
  }

  return <Suspense fallback={fallback}>{pageComponent}</Suspense>;
}

// NOTE: This is a polyfill for `import.meta.env.BASE_URL` as it's not available in Webpack environment.
export const BASE_URL =
  window.kcContext === undefined || process.env.NODE_ENV === 'development'
    ? process.env.PUBLIC_URL === ''
      ? '/'
      : `${process.env.PUBLIC_URL}/`
    : `${window.kcContext['x-keycloakify'].resourcesPath}/dist/`;

// NOTE: This is only exported here because you're supposed to import type from different packages
// Depending of if you are using Vite, Webpack, ect...
export type { Meta, StoryObj } from '@storybook/react-webpack5';
